/**
 * @generated SignedSource<<35671c2f9eef457d9e3125ca353c911c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type IssueStatusCategoryCell$data = {
  readonly id?: string;
  readonly statusCategory: {
    readonly name: string | null | undefined;
    readonly statusCategoryId: string;
  };
  readonly " $fragmentType": "IssueStatusCategoryCell";
};
export type IssueStatusCategoryCell$key = {
  readonly " $data"?: IssueStatusCategoryCell$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueStatusCategoryCell">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "IssueStatusCategoryCell",
  "selections": [
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "id"
        }
      ]
    },
    {
      "concreteType": "JiraStatusCategory",
      "kind": "LinkedField",
      "name": "statusCategory",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "name"
        },
        {
          "kind": "ScalarField",
          "name": "statusCategoryId"
        }
      ]
    }
  ],
  "type": "JiraStatusCategoryField"
};

(node as any).hash = "78312f73d48c26a2fd08269cb3f1b716";

export default node;
